(function () {
  function syncVariantUi(card, swatch) {
    if (!card || !swatch || !swatch.dataset.variantId) return;
    const vid = swatch.dataset.variantId;
    const available = swatch.dataset.available === 'true';
    const inv = swatch.dataset.inventory !== undefined && swatch.dataset.inventory !== '' ? swatch.dataset.inventory : '';
    card.dataset.variantId = vid;
    if (inv !== '') card.dataset.inventory = inv;
    card.dataset.available = available ? 'true' : 'false';
    card.querySelectorAll('.card__add-to-cart input[name="id"], input[name="id"]').forEach(function (inp) {
      if (card.contains(inp)) inp.value = vid;
    });
    card.querySelectorAll('button[name="add"][id$="-submit"]').forEach(function (btn) {
      if (!card.contains(btn)) return;
      btn.dataset.variantId = vid;
      btn.dataset.available = available ? 'true' : 'false';
      if (inv !== '') btn.dataset.inventory = inv;
    });
  }

  function swapImage(card, imgUrl, variantId, swatch) {
    const primaryImg = card.querySelector('.card__primary-image');
    if (!primaryImg || !imgUrl) return;
    primaryImg.src = imgUrl;
    primaryImg.srcset = imgUrl + ' 800w';
    if (variantId) {
      rememberCardVariant(card, variantId);
      const baseUrl = card.querySelector('.card-wrapper__link--overlay, .js-color-swatches-link')?.href?.split('?')[0];
      if (baseUrl) {
        const newHref = baseUrl + '?variant=' + variantId;
        card.querySelectorAll('.card-wrapper__link--overlay, .js-color-swatches-link, .card__title a.full-unstyled-link').forEach(function (link) {
          link.href = newHref;
        });
      }
      if (swatch && swatch.classList.contains('card-color-swatch')) {
        syncVariantUi(card, swatch);
      }
    }
  }

  function getActiveSwatch(card) {
    const swatches = card.querySelector('.card-color-swatches');
    if (!swatches) return null;
    return swatches.querySelector('.card-color-swatch--active');
  }

  function getCardVariantId(card) {
    const activeSwatch = getActiveSwatch(card);
    if (activeSwatch && activeSwatch.dataset.variantId) {
      return activeSwatch.dataset.variantId;
    }
    return card.dataset.variantId || '';
  }

  function rememberCardVariant(card, variantId) {
    const handle = card.dataset.product;
    if (!handle || !variantId) return;
    try {
      sessionStorage.setItem('sasi_pdp_variant:' + handle, String(variantId));
    } catch (e) {
      /* ignore */
    }
  }

  function handleSwatchSelect(e) {
    const swatch = e.target.closest('.card-color-swatch');
    if (!swatch || !swatch.dataset.cardId) return;

    const cardId = swatch.dataset.cardId;
    const card = document.querySelector('[data-card-id="' + cardId + '"]');
    if (!card) return;

    const imgUrl = swatch.dataset.variantImageUrl || card.dataset.defaultImageUrl;
    if (!imgUrl) return;

    swapImage(card, imgUrl, swatch.dataset.variantId, swatch);
    swatch.closest('.card-color-swatches')?.querySelectorAll('.card-color-swatch--active').forEach(function (s) {
      s.classList.remove('card-color-swatch--active');
    });
    swatch.classList.add('card-color-swatch--active');
  }

  function handleSwatchActivate(e) {
    handleSwatchSelect(e);
    var swatch = e.target.closest('.card-color-swatch');
    if (swatch && e.cancelable) {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  document.addEventListener('mouseover', function (e) {
    handleSwatchSelect(e);
    var media = e.target.closest('.media');
    if (media) {
      var card = media.closest('.card-wrapper');
      if (card && card.querySelector('.card-color-swatches')) {
        var activeSwatch = getActiveSwatch(card);
        var secondUrl = activeSwatch && activeSwatch.dataset.variantSecondImageUrl;
        if (!secondUrl) {
          secondUrl = card.dataset.cardMfSecondUrl;
        }
        if (secondUrl && activeSwatch && activeSwatch.dataset.variantId) {
          swapImage(card, secondUrl, activeSwatch.dataset.variantId, activeSwatch);
        }
      }
    }
  });

  document.addEventListener('mouseout', function (e) {
    var media = e.target.closest('.media');
    if (media && !media.contains(e.relatedTarget)) {
      var card = media.closest('.card-wrapper');
      if (card && card.querySelector('.card-color-swatches')) {
        var activeSwatch = getActiveSwatch(card);
        if (activeSwatch && activeSwatch.dataset.variantImageUrl) {
          swapImage(card, activeSwatch.dataset.variantImageUrl, activeSwatch.dataset.variantId, activeSwatch);
        }
      }
    }
    /* Do not revert to default when leaving the card; keep the last hovered variant's image */
  });

  document.addEventListener('click', handleSwatchActivate, true);

  const applyActiveSwatchToProductLink = function (link) {
    const card = link.closest('[data-card-id]');
    if (!card || !card.querySelector('.card-color-swatches')) return;
    const variantId = getCardVariantId(card);
    if (!variantId) return;
    rememberCardVariant(card, variantId);
    try {
      const url = new URL(link.href, window.location.origin);
      url.searchParams.set('variant', variantId);
      link.href = url.pathname + url.search + url.hash;
    } catch (e) {
      const base = String(link.getAttribute('href') || '').split('?')[0];
      if (base) link.href = base + '?variant=' + variantId;
    }
  };

  document.addEventListener(
    'click',
    function (e) {
      const link = e.target.closest(
        '.card-wrapper__link--overlay, .js-color-swatches-link, .card__title a.full-unstyled-link'
      );
      if (!link || !link.href || link.href === '#') return;
      applyActiveSwatchToProductLink(link);
    },
    true
  );

  document.addEventListener('touchstart', function (e) {
    var swatch = e.target.closest('.card-color-swatch');
    if (swatch) {
      handleSwatchSelect(e);
      e.preventDefault();
    }
  }, { passive: false });

})();
